export default __webpack_public_path__ + "static/media/teacher.acb493e2.svg";